export default "__VITE_ASSET__wq6E1m24__"